import { css } from "@emotion/css";
import styled from "@emotion/styled";

export const HelpImage = styled.img`
    width: 97.22px;
`;

export const SectionHeader = styled.h3`
    overflow: hidden;

    width: 100%;
    margin-top: 37px;
    margin-bottom: 18px;

    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const SelectSubmitAccountContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    margin-top: 48px;
    padding: 24px 80px;

    text-align: center;

    background-color: #fff;
    border: 1px solid #fff;
    border-radius: 6px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 6%);
`;

export const linkStyle = css`
    margin-top: 8px;
`;
